<template>
<b-card header="Customer" header-bg-variant=primary>
  <b-form-row class='my-1'>
    <b-col cols=1><label>Email</label></b-col>
    <b-col cols=4>
      <input-merger :dict=order.email :disabled=disabled @input=checkCustomerExists>
        <template slot=append>
          <b-input-group-text>
              <span v-if=loadingUser><i class='fas fa-spinner fa-spin'></i></span>
              <span v-if=userExists v-b-popover.hover=order.customerId><i class='fas fa-check'></i></span>
              <span v-else v-b-popover.hover="'No Account!'"><i class='fas fa-times'></i></span>
          </b-input-group-text>
          <b-btn size=sm variant=primary :disabled=disabled v-if=userSync @click=associateCustomer>
            Associate with Customer
          </b-btn>
        </template>
      </input-merger>
    </b-col>
    <b-col cols=1><label>Program</label></b-col>
    <b-col cols=3>
      <input-merger :dict={} :disabled=disabled />
    </b-col>
    <b-col cols=1><label>Team #</label></b-col>
    <b-col cols=2>
      <input-merger :dict={} :disabled=disabled />
    </b-col>
  </b-form-row>
  <b-form-row class='my-1'>
    <b-col cols=1><label>Order Notes</label></b-col>
    <b-col cols=11>
      <input-merger :dict={} :disabled=disabled :textarea="true" />
    </b-col>
  </b-form-row>
</b-card>
</template>

<script>
import InputMerger from '../../utility/InputMerger'

export default {
  props: {
    order: { type: Object, required: true },
    disabled: { type: Boolean, default: false },
  },
  components: {
    InputMerger,
  },
  methods: {
    checkCustomerExists() {

    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/sales-order/edit-order-2/CustomerEditor.vue